"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const core_1 = require("@material-ui/core");
const style_1 = tslib_1.__importDefault(require("../../../../../utils/style"));
function ModelTuningStep2(props) {
    const { checkedModelDetails, saveCheckedModel, isModelSaved, decreaseStep } = props;
    const styleLocal = style_1.default();
    react_1.useEffect(() => {
        console.log("ModelTuningStep 2", checkedModelDetails);
    }, []);
    const paramNames = {
        r2_score: "Coefficient of Determination",
        mean_absolute_error: "Mean Absolute Error",
        mean_squared_error: "Mean Squared Error",
        algorithm: "Model Name",
        accuracy: "Accuracy",
        precision: "Precision",
        recall: "Recall",
        f1_score: "F1 Score",
        smape_value: "Smape Value",
    };
    const formatValue = (value) => {
        return typeof value === 'number' ? value.toFixed(3) : value;
    };
    const normalizeKey = (key) => {
        return key.replace(/-/g, '_');
    };
    return (react_1.default.createElement(core_1.Grid, { container: true, justifyContent: "center" },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 8, lg: 8, style: { backgroundColor: "white", padding: "30px", marginBottom: "80px" } },
            react_1.default.createElement(core_1.Typography, { className: styleLocal.topicFont, style: { marginBottom: "2px", fontWeight: 900, fontSize: 16 } }, "Performance Report"),
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 }, Object.keys(checkedModelDetails).map((param) => {
                const normalizedParam = normalizeKey(param);
                return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 6, lg: 6, key: param },
                    react_1.default.createElement(core_1.Box, { marginBottom: 2 },
                        react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont, style: { fontSize: 16, color: "#324054" } }, paramNames[normalizedParam]),
                        react_1.default.createElement(core_1.Box, { sx: {
                                height: 30,
                                display: "flex",
                                alignItems: "center",
                                border: "1px solid #ccc",
                                borderRadius: 1,
                                padding: "0 10px",
                                color: "#324054",
                            } },
                            react_1.default.createElement(core_1.Typography, { variant: "body2", style: { fontSize: 14, color: "#324054" } }, formatValue(checkedModelDetails[param]))))));
            }))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 })));
}
exports.ModelTuningStep2 = ModelTuningStep2;
//# sourceMappingURL=model-tuning-step2.js.map